import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisH } from '@fortawesome/pro-solid-svg-icons/faEllipsisH';

import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import messages from './messages';
import styles from './provider-actions-menu.module.less';

const preventDefault = (e) => e?.preventDefault();

export const ProviderActionsMenu = ({ children }) => {
  const { formatMessage } = useIntl();
  return (
    <DropdownMenu menuPosition='bottom-right'>
      <DropdownMenuToggler
        ariaLabel={formatMessage(messages.openActionsMenu)}
        className={styles['menu-toggle']}
        hideChevron
        onClick={preventDefault}
        openClassName={styles['open-menu-toggle']}
        theme='link'
      >
        <div className={styles['menu-toggle-contents']}>
          <FontAwesomeIcon icon={faEllipsisH} />
        </div>
      </DropdownMenuToggler>
      {children}
    </DropdownMenu>
  );
};

ProviderActionsMenu.propTypes = {
  children: PropTypes.node.isRequired,
};
